/**
 * Project Service
 * AIDLC Administrative Backend
 *
 * API calls for project and AIDLC lifecycle operations.
 * Maps to endpoints defined in the Architecture Document, Section 04.
 */

import apiClient from './api';
import type { Project, AidlcState, ProjectEconomics } from '../types/project';

const PROJECTS_PATH = '/projects';

export async function getAllProjects(): Promise<Project[]> {
  const response = await apiClient.get<Project[]>(PROJECTS_PATH);
  return response.data;
}

export async function getProjectById(projectId: string): Promise<Project> {
  const response = await apiClient.get<Project>(`${PROJECTS_PATH}/${projectId}`);
  return response.data;
}

export async function createProject(
  project: Omit<Project, 'id' | 'createdAt' | 'updatedAt' | 'stateHistory'>
): Promise<Project> {
  const response = await apiClient.post<Project>(PROJECTS_PATH, project);
  return response.data;
}

export async function transitionProjectState(
  projectId: string,
  newState: AidlcState,
  notes: string
): Promise<Project> {
  const response = await apiClient.put<Project>(
    `${PROJECTS_PATH}/${projectId}/state`,
    { state: newState, notes }
  );
  return response.data;
}

export async function getProjectEconomics(projectId: string): Promise<ProjectEconomics> {
  const response = await apiClient.get<ProjectEconomics>(`${PROJECTS_PATH}/${projectId}/economics`);
  return response.data;
}

export async function getProjectTimeline(
  projectId: string
): Promise<{ events: unknown[] }> {
  const response = await apiClient.get(`${PROJECTS_PATH}/${projectId}/timeline`);
  return response.data;
}
